// reducers/employee-onboarding/receipt.js

export function receiptHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RECEIPT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function receiptIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_RECEIPT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function receipt(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_RECEIPT_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}